<template>
  <el-aside
    width="201px"
    :style="{
      position: 'fixed',
      height: 'calc(100vh - 48px)',
      left: 0,
      top: '48px',
      overflow: 'auto',
      background: 'rgb(20, 31, 41)',
      boxSizing: 'border-box'
    }"
  >
    <!--:default-active是为了刷新后默认打开之前的激活菜单项，它的值是激活菜单项的index值 :default-active="activePath"-->
    <div ref="menuBlock" :style="'height:' + menuBlockHeight + 'px'" class="sider-menu-block">
      <el-menu
        background-color="rgba(20, 31, 41)"
        text-color="rgb(224, 225, 226)"
        active-text-color="#00A16C"
        @select="onSelect"
        :default-active="activePath"
      >
        <template v-for="(item, i) in menuList">
          <el-submenu :index="i.toString()">
            <!--            第一层-->
            <template slot="title">
              <i
                :class="item.icon"
                style="color: #ffffff; display: inline-block; margin-right: 10px; position: relative; left: -5px"
              ></i>
              <el-tooltip v-if="isEnglish" class="item" effect="dark" :content="item.name" placement="right">
                <span :class="{ en: isEnglish }">{{ item.name }}</span>
              </el-tooltip>
              <span v-else :class="{ en: isEnglish }">{{ item.name }}</span>
            </template>
            <!--    :key="id"         第二层-->
            <el-menu-item
              :index="i + '-' + j"
              v-if="!child.children"
              v-for="(child, j) in item.children"
              :key="j"
              @click="saveMenuActive(i, j)"
              class="menu-item"
              :class="{ en: isEnglish }"
            >
              <div
                style="
                  height: 18px;
                  width: 5px;
                  display: inline-flex;
                  align-items: center;
                  position: relative;
                  left: -10px;
                "
              >
                <div class="point" style="border-radius: 50%; width: 5px; height: 5px; background: #ffffff"></div>
              </div>
              {{ child.name }}
            </el-menu-item>
            <!--            第三层-->
            <el-submenu :index="i + '-' + j" v-else>
              <template slot="title">{{ child.name }}</template>
              <el-menu-item
                v-for="(c, k) in child.children"
                :index="i + '-' + j + '-' + k"
                :key="k"
                @click="saveMenuActive(i, j, k)"
                >{{ c.name }}</el-menu-item
              >
            </el-submenu>
          </el-submenu>
        </template>
      </el-menu>
    </div>
  </el-aside>
</template>

<script>
// import { findWithMe } from '@/project/service/module-permission'
// const menuList = require('./menuList.json')
import { EventBus } from './event-bus.js'
export default {
  name: 'SiLayoutLeft',
  inject: ['reload'],
  props: {
    active: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      menuList: [],
      menuBlockHeight: 0,
      activePath: '',
      link: this.$route.path
    }
  },
  computed: {
    isEnglish() {
      return this.$store.state.language === 'en'
    },
    path() {}
  },
  created() {
    // 获取保存在缓存中的路径，保持菜单当前选中菜单项不变
    this.activePath = window.sessionStorage.getItem('activePath')
    EventBus.$on('changeActivePath', path => {
      this.activePath = path.activePath
      this.link = path.link
      window.sessionStorage.setItem('activePath', path.activePath)
    })
    // let client = this.$store.state.user.role.slice(0, 1).toUpperCase() + this.$store.state.user.role.slice(1)
    // // 根据
    // findWithMe({ client }, res => {
    //   this.menuList = res
    // })
  },
  mounted() {},
  methods: {
    onSelect(name, path) {
      console.log('name', name, 'path', path)
      let menuList = this.menuList
      let flag = typeof name === 'number'
      let link = '/'
      let displayName = ''
      if (flag) {
        // 如果flag是数字类型则表示点击的是一级菜单
        link = menuList[name].path
        displayName = menuList[name].name
      } else {
        // 如果不是则表示点击的是二级菜单
        console.log('点击二级')
        let arr = name.split('-')
        if (arr.length === 2) {
          // 第二层数据
          console.log('二层数据')
          link = menuList[arr[0]].children[arr[1]].path
          displayName = menuList[arr[0]].children[arr[1]].name
          console.log(displayName, link)
        } else {
          // 第三层数据
          link = menuList[arr[0]].children[arr[1]].children[arr[2]].path
          displayName = menuList[arr[0]].children[arr[1]].children[arr[2]].name
        }
      }
      console.log('link', link)
      console.log('this.link', this.link, link === this.link, this.$route.path)
      if (link === this.link) {
        this.reload()
      } else {
        this.$router.push(link)
      }
      this.link = link
    },
    // 保存菜单激活状态
    saveMenuActive(...args) {
      // 如果是二级菜单
      if (args.length === 2) {
        let activePath = args[0] + '-' + args[1]
        console.log('8888888', activePath)
        window.sessionStorage.setItem('activePath', activePath)
        this.activePath = activePath
      } else {
        // 如果是三级菜单
        let activePath = args[0] + '-' + args[1] + '-' + args[2]
        window.sessionStorage.setItem('activePath', activePath)
        this.activePath = activePath
      }
    }
    // getByMenu() {
    //   if (localStorage.menuList) {
    //     let menuList = JSON.parse(localStorage.menuList)
    //     this.menuList = menuList.map(first => {
    //       if (first.children) {
    //         return {
    //           displayName: first.name,
    //           icon: first.icon,
    //           children: first.children.map(second => {
    //             if (second.children) {
    //               return {
    //                 displayName: second.name,
    //                 icon: '',
    //                 children: second.children.map(third => {
    //                   return {
    //                     displayName: third.name,
    //                     icon: ''
    //                   }
    //                 }),
    //                 level: 3
    //               }
    //             } else {
    //               return {
    //                 displayName: second.name,
    //                 icon: '',
    //                 link: second.path,
    //                 level: 2
    //               }
    //             }
    //           })
    //         }
    //       } else {
    //         return {
    //           displayName: first.name,
    //           icon: 'el-icon-setting',
    //           link: first.path,
    //           level: 1
    //         }
    //       }
    //     })
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
.sider-logo {
  color: #57b382;
  font-weight: bolder;
  width: 100%;
  text-align: center;
  font-size: 15px;
  line-height: 40px;
  margin: 10px 0;
}
.menu-item {
  &.en {
    font-size: 13px !important;
  }
}
.el-menu-item:hover {
  background: #57b382 !important;
}
.el-aside {
  /*!*隐藏滚动条，当IE下溢出，仍然可以滚动*!*/
  /*-ms-overflow-style:none;*/
  /*!*火狐下隐藏滚动条*!*/
  /*overflow:-moz-scrollbars-none;*/
  &::-webkit-scrollbar {
    display: none;
  }
}
.el-menu-item {
  background: #09121a !important;
  height: 52px;
  line-height: 52px;
  font-size: 14px !important;
  user-select: none;
}
.el-menu-item:hover {
  background: #09121a !important;
}
.el-menu-item:hover .point {
  background: #00a16c !important;
}
.el-menu-item.is-active {
  background-color: #00aa72 !important;
  color: #fff !important;
}
.el-menu-item.is-active .point {
  background-color: #ffffff !important;
}
.el-submenu /deep/ .el-submenu__title {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
}
.el-menu /deep/ .el-submenu__title span {
  letter-spacing: 2px;
  user-select: none;
  &.en {
    letter-spacing: 0px;
    font-size: 13px;
    display: inline-block;
    width: 100px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
}
</style>



// WEBPACK FOOTER //
// src/framework/layout/layout-left.vue